import { RPCs } from "../../../services/rpc.js";
import { useRPC } from "../../../hooks/useRPC/index.js";
//#region src/modules/Scheduling/hooks/useUserCurrentOrFutureShift.ts
function useUserCurrentOrFutureShift(userId, opts = {}) {
	const fire = typeof opts.fire === "boolean" ? opts.fire : true;
	const { call, data, isCalling } = useRPC(RPCs.Scheduling.GetUserCurrentOrFutureShift.v1, userId ? { userId } : void 0, {
		cacheStrategy: opts.cacheStrategy,
		fire
	});
	return {
		data,
		loading: isCalling,
		refresh: call
	};
}
//#endregion
export { useUserCurrentOrFutureShift };

//# sourceMappingURL=useUserCurrentOrFutureShift.js.map